import items from './items';
import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import quickUpdate from './quickUpdate';
import all from './all';
import allBasic from './allBasic';
import transactions from './transactions';
import transactionsV2 from './transactionsV2';
import merge from './merge';
import search from './search';
import searchAll from './searchAll';
import counts from './counts';
import bulkUpdate from './bulkUpdate';
import bulkSyncToWoo from './bulkSyncToWoo';
import removeImage from './removeImage';

export default {
  items,
  destroy,
  store,
  show,
  update,
  all,
  allBasic,
  transactions,
  transactionsV2,
  merge,
  search,
  searchAll,
  quickUpdate,
  counts,
  bulkUpdate,
  bulkSyncToWoo,
  removeImage,
};



// WEBPACK FOOTER //
// ./src/app/services/product/index.js